export enum AwsInspectorService {
  EC2 = 'ec2',
  ECR = 'ecr',
  Lambda = 'lambda',
  LambdaCode = 'lambda-code',
}

export enum AwsInspectorResourceStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  SUSPENDED = 'SUSPENDED',
}
